import { render, staticRenderFns } from "./simple-table.vue?vue&type=template&id=6efe186d&"
import script from "./simple-table.vue?vue&type=script&lang=ts&"
export * from "./simple-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports